/**
 * Reusable greensock functions
 */
import { gsap } from "gsap";    
import { ScrollTrigger } from "gsap/ScrollTrigger";

import { SplitText } from "gsap/SplitText";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(SplitText);


/*
*   Home Page
*/

// Info Panels: Slide in from left when section enters viewport
const items = gsap.utils.toArray('.info-slab-wrapper');
gsap.from(items, {
  x: -100,                 // slide in from left
  opacity: 0,
  duration: 0.8,
  ease: 'power3.out',
  stagger: 0.15,
  scrollTrigger: {
    trigger: '.column-info-slabs',
    start: 'top 75%',      // when top of section hits 25% of viewport
    toggleActions: 'play none none none',
    once: true
  }
});


// Info Cards: Flip in when section enters viewport
gsap.utils.toArray(".pattern-grid-cards").forEach((section) => {
  const cards = section.querySelectorAll(".grid-card");
  if (!cards.length) return;

  // Initial state
  gsap.set(cards, {
    opacity: 0,
    rotateY: -80,
    x: -40,
    transformPerspective: 1200
  });

  // Animate in on scroll
  gsap.to(cards, {
    opacity: 1,
    rotateY: 0,
    x: 0,
    duration: 0.9,
    ease: "power3.out",
    stagger: 0.15,
    scrollTrigger: {
      trigger: section,
      start: "top 75%",
      toggleActions: "play none none none",
      once: true
    }
  });
});

/*
*   Slide Animations
*/
// document.querySelectorAll('.slide-right-to-left').forEach(el => {
//   ScrollTrigger.create({
//     trigger: el,
//     start: "top bottom",
//     onEnter: () => el.classList.add('animate')
//   });
// });

// document.querySelectorAll('.slide-left-to-right').forEach(el => {
//   ScrollTrigger.create({
//     trigger: el,
//     start: "top bottom",
//     onEnter: () => el.classList.add('animate')
//   });
// });
